export default "__VITE_ASSET__2n1BTEQC__"